import React from "react";
import ForgotPass from "../Components/Login/ForgotPass";

const ForgotPassPage = () => {
  return <ForgotPass />;
};

export default ForgotPassPage;
